import React, {Fragment} from 'react';
import Link from 'react-router-dom/Link';
import { Row, Col, List, Avatar, Icon, Button } from 'antd';
import './ApplicationsSection.css';
// import imgApplications from '../../images/500/businessman-2682712_1920.jpg';
import imgApplications from '../../images/500/humanitarian-2723672_1920(1.jpg';

const data = [
  { 
    title: 'Rural Communities: Remote and local diagnosis and vital signs reports for doctor, nurse, and patient',
  },
  {
    title: 'Remote Monitoring: Medicine release, medication adherence verification, and monitoring',
  },
  {
    title: 'Real Time Video Physical Therapies. Testing of reflexes and stretching are enhanced with real-time physical interaction',
  },
  {
    title: 'Law enforcement and military: A variety of specialist occupations require remote health advice and treatments',
  },
];

const ApplicationsSection = (props) => {

   return (
      <Fragment>
      <div className="ApplicationsSection--container">
        
        <div className="ApplicationsSection--container-inner img-rounded">
          <div className="ApplicationsSection--headline">
            <h2> 
              <Icon type="solution" style={{marginRight:15}}/>Telemedicine Applications & Use Cases
            </h2>
          </div>
          <Row>
            <Col sm ={24} md={8} style={{float:'left'}}>
              <Link to="/applications/">
              <div className="ApplicationsSection--image">
                <img className="ApplicationsSection--img-main img-responsive img-rounded" alt="app1" src={imgApplications} />
              </div>
              </Link>
            </Col>
            <Col sm={24} md={16}>
              <div className="ApplicationsSection--description">
                <div className="ApplicationsSection--subheadline">
                    Real Time Touch patents offer cutting-edge solutions for health technology
                </div>
                <div className="ApplicationsSection--body-text">
                  <p>
                  Real Time Touch is strategically positioned with key intellectual property rights. We're seeking partners to develop this innovative mobile health patent in a billion+ dollar growing market.
                  </p>
                  <div className="ApplicationsSection--container-list">
                    <List 
                      itemLayout="horizontal"
                      dataSource={data}
                      renderItem={item => (
                        <List.Item>
                          <List.Item.Meta
                            avatar={<Avatar icon="solution" />}
                            title={<span className="ApplicationsSection--list-item-headline">{item.title}</span>}
                            description=""
                          />
                        </List.Item>
                      )}
                    />
                  </div>

                  {/* <p>
                  The opportunities available with Real Time Touch intellectual property are tremendous. 
                  </p> */}

                </div>
              </div>            
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div className="ApplicationsSection--button-moreinfo">
                <Link to="/applications/">
                  <Button size="large" type="primary"><Icon type="solution" style={{marginRight:5}}/>Telemedicine Applications<Icon type="caret-right" /></Button>
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      </Fragment>
    )
 }

 export default ApplicationsSection;


// WEBPACK FOOTER //
// ./src/containers/ApplicationsSection/ApplicationsSection.js